import React, {useContext, useEffect, useRef, useState} from 'react';
import './style.scss';
import {AppContext} from "../../Utils/AppContext";
import {publish} from "../../../Events/events";
import {
    GroupClickedOnGroupsToolbar,
    GroupHoverOnGroupsToolbar,
    GroupHoverOutOnGroupsToolbar
} from "../../../Events/topics";
import RouteTimeCircle from "../../RouteTimeCircle/RouteTimeCircle";
import {secondsUntil} from "../../../Utils/TimeUtils";

export default function SentRoute(props) {
    const appContext = useContext(AppContext);
    const [groupColor, setGroupColor] = useState('transparent');
    const isCurrentlyHover = useRef(false);

    useEffect(() => {
        setGroupColor(appContext.iconColors.getColorByGroupId(props.route.id).primaryColor);
    }, [props.route]);

    const onRouteHover = (e) => {
        if (!isCurrentlyHover.current) {
            const orderIds = props.route.route.map(stop => stop.order_id);

            publish(GroupHoverOnGroupsToolbar, {orderIds: orderIds});

            isCurrentlyHover.current = true;
        }
    };

    const onRouteHoverOut = (e) => {
        const orderIds = props.route.route.map(stop => stop.order_id);

        publish(GroupHoverOutOnGroupsToolbar, {orderIds: orderIds});

        isCurrentlyHover.current = false;
    };

    const onRouteClicked = (e) => {
        if (e.defaultPrevented)
            return;

        const orderIds = props.route.route.map(stop => stop.order_id);

        publish(GroupClickedOnGroupsToolbar, {orderIds: orderIds});

        if (props.onGroupClick)
            props.onGroupClick(e);
    };

    const messenger = props.users.find(user => user.id === props.route.messenger_id);

    return (
        <div
            className={"sent-route"}
            onMouseOver={onRouteHover}
            onMouseLeave={onRouteHoverOut}>
            <div
                className="sent-route-content"
                onClick={onRouteClicked}
                style={{border: `6px solid ${groupColor}`}}>
                <div className="route-info">
                    <div className="top-section">
                        {
                            messenger?.name && props.route.status !== "SEARCHING_FOR_DRIVER" ?
                                <div className="messenger-info">
                                    {messenger.name}
                                </div>
                                :
                                null
                        }
                        <span className="route-time-circle-wrapper">
                            <RouteTimeCircle status={props.route.status}
                                             totalDuration={props.route.duration}
                                             durationTillFinish={secondsUntil(props.route.real_time_finish_time)}/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}